import { getMangoApiClient } from '~/atoms/MangoApi'

import { createWebhooksApi } from '@mangovoice/webhooks-ui'

export const webhooksApi = createWebhooksApi(getMangoApiClient().webhooks)
